<template>
  <div
    class="btn-group-spaced"
    :class="{ 'is-justified': isMonthMode }"
  >
    <AppButton
      v-for="day in availableDays"
      :key="day.value"
      class="btn-sm btn-default"
      :class="{ active: isDaySelected(day), 'btn-circle': isWeekMode, 'btn-rounded': isMonthMode }"
      :disabled="disabled"
      @click="toggleDay(day)"
    >
      {{ day.name }}
    </AppButton>
  </div>
</template>

<script>
const WEEK_DAYS = [
  { name: 'Su', value: 0 },
  { name: 'Mo', value: 1 },
  { name: 'Tu', value: 2 },
  { name: 'We', value: 3 },
  { name: 'Th', value: 4 },
  { name: 'Fr', value: 5 },
  { name: 'Sa', value: 6 },
];
const MONTH_DAYS = [
  { name: 'First day of the month', value: 0 },
  { name: '15th of the month', value: 1 },
  { name: 'Last day of the month', value: 2 },
];

export default {
  name: 'AppIntervalDayPicker',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: 'week',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: [],
    };
  },
  computed: {
    availableDays() {
      if (this.isWeekMode) {
        return WEEK_DAYS;
      }
      if (this.isMonthMode) {
        return MONTH_DAYS;
      }

      return [];
    },
    availableDaysValues() {
      return this.availableDays.map((day) => day.value);
    },
    isWeekMode() {
      return this.mode === 'week';
    },
    isMonthMode() {
      return this.mode === 'month';
    },
  },
  watch: {
    value() {
      this.processValue();
    },
  },
  created() {
    this.processValue();
  },
  methods: {
    processValue() {
      this.currentValue = this.value ? this.filterValidDays(this.value) : [];
    },
    toggleDay(day) {
      if (!this.isDaySelected(day)) {
        this.selectDay(day);
      } else {
        this.deselectDay(day);
      }
    },
    deselectDay(day) {
      const index = this.currentValue.indexOf(day.value);

      this.currentValue.splice(index, 1);
      this.onChange();
    },
    selectDay(day) {
      if (this.multiple) {
        this.currentValue.push(day.value);
      } else {
        this.currentValue = [day.value];
      }

      this.onChange();
    },
    isDaySelected(day) {
      return this.currentValue.indexOf(day.value) >= 0;
    },
    filterValidDays(values) {
      return values.map(Number).filter((value) => {
        return this.availableDaysValues.includes(value);
      });
    },
    onChange() {
      this.$emit('input', this.currentValue);
    },
  },
};
</script>
